import React, { Component } from 'react';
import Search from './pages/search';
import ReplayDetails from './pages/replayDetails';
import Status from './pages/status';
import Cache from './pages/cache'
import Documents from './pages/documents'
import ApiTest from './pages/apiTest';
import Login from './pages/login';
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import { Container } from 'react-bootstrap';
import NavBar from './components/navBar';
import './App.css';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <NavBar />
        <Container className="App">
          <Switch>
						<PrivateRoute path="/search" component={Search} />
          	<PrivateRoute exact path="/status" component={Status} />
          	<PrivateRoute exact path="/api" component={ApiTest} />
            <PrivateRoute exact path="/cache" component={Cache} />
            <PrivateRoute exact path="/docs" component={Documents} />
          	<Route exact path="/login" component={Login} />
            <Redirect from="*" to="/search" />
            <Redirect from="*" to={{pathname:'/search', state:{ from: '/search'}}} />
          </Switch>
          <Route exact path="/search/:id" component={ReplayDetails} />
        </Container>
      </BrowserRouter>
    );
  }
}

function PrivateRoute ({component: Component, ...rest}) {
	localStorage.setItem('original_path', rest.location.pathname);
  
	return (
    <Route
      {...rest}
      render={(props) => localStorage.getItem('token') !== null
        ? <Component {...props} />
        : <Redirect to={{pathname: '/login', state: {from: props.location}}} />}
    />
  )
}

export default App;
